import { render } from "./simpleButton.vue?vue&type=template&id=2abbfd69&scoped=true"
import script from "./simpleButton.vue?vue&type=script&lang=js"
export * from "./simpleButton.vue?vue&type=script&lang=js"

import "./simpleButton.vue?vue&type=style&index=0&id=2abbfd69&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abbfd69"]])

export default __exports__